
import Button from "@/components/base/Button"

import { mdiChevronLeft } from "@mdi/js"

export default {
    name: "BlurredModal",
    components: { Button },
    props: {
        /** Image Object */
        img: {
            type: Object,
            default: null,
        },
        /** Controlls the dialog open state */
        value: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        mdiChevronLeft,
    }),
    computed: {
        backgroundImage() {
            if (!this.img) return "background: black"
            return {
                "background-image": `url(${this.backgroundSrc})`,
            }
        },
        backgroundSrc() {
            return this.$getImage({
                image: this.img,
                preferedSize: "1",
            }).src
        },
    },
    methods: {
        close() {
            this.$emit("input", false)
        },
    },
}
